var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconTooltipInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.9775 5.49003C11.6925 2.19003 8.79003 -0.262473 5.49003 0.0225275C2.19003 0.307527 -0.262473 3.21003 0.0225275 6.51003C0.307527 9.81003 3.21003 12.2625 6.51003 11.9775C9.81003 11.7 12.2625 8.79003 11.9775 5.49003ZM6.75003 9.00003C6.75003 9.41253 6.41253 9.75003 6.00003 9.75003C5.58753 9.75003 5.25003 9.41253 5.25003 9.00003V6.00003C5.25003 5.58753 5.58753 5.25003 6.00003 5.25003C6.41253 5.25003 6.75003 5.58753 6.75003 6.00003V9.00003ZM6.00003 3.75003C5.58753 3.75003 5.25003 3.41253 5.25003 3.00003C5.25003 2.58753 5.58753 2.25003 6.00003 2.25003C6.41253 2.25003 6.75003 2.58753 6.75003 3.00003C6.75003 3.41253 6.41253 3.75003 6.00003 3.75003Z",
    fill: "#49575E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTooltipInfo);
export default __webpack_public_path__ + "static/media/icon-tooltip-info.30e960305f2491d81e63afe44df4663e.svg";
export { ForwardRef as ReactComponent };